import { createElement, CSSProperties } from 'react';
import { TableItemData } from './internal';
import { RadioButton } from '../../RadioButton/__internal__';

export const SelectionRadioButton = (props: {
  itemData: TableItemData;
  rowIndex: number;
  style: CSSProperties;
  selected?: boolean;
}) => {
  const {
    getRowIdentifier,
    getRowIndex,
    rowCount,
    singleSelectionOverrides,
    hideSelectAll,
    areRowsVisible,
    setSelectRow,
    isRowDisabled,
    isRowReadOnly,
    readOnly,
  } = props.itemData;
  const rowKey = props.rowIndex !== -1 ? getRowIdentifier(props.rowIndex) : undefined;
  const disabled = rowKey ? !!isRowDisabled?.(rowKey) : false;
  const readOnlyRow = readOnly || (rowKey && !!isRowReadOnly?.(rowKey));
  const selectedRows = props.itemData.preference?.selectedRows;

  return (
    <div
      style={props.style}
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      onClick={() => {
        if (disabled || readOnlyRow) return;
        props.itemData?.setInteractiveAction?.(true);
        setSelectRow?.({
          index: props.rowIndex,
          selected:
            singleSelectionOverrides?.allowDeselection &&
            selectedRows?.has(getRowIdentifier(props.rowIndex))
              ? false
              : true,
          selectionType: 'radioButton',
          clearPrevious: true,
          rowCount,
          rangeSelection: false,
          rowKey: getRowIdentifier,
          getRowIndex,
          hideSelectAll,
          areRowsVisible,
          isRowDisabled,
          isRowReadOnly,
        });
      }}
    >
      <RadioButton
        selected={props.selected}
        testId={`row-${props.rowIndex}`}
        focusable={false}
        disabled={disabled}
        readOnly={!!readOnlyRow}
      />
    </div>
  );
};
